import { Checkbox, Divider, Form, FormInstance, Input, Modal, Select } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { commonPresenter, commonStore, driverPresenter, driverStore } from 'stores/root_store'
import { validateLicensePlate, validatePhone } from 'utils/validateHelper'

import { CardBox } from './cardBox'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { Driver } from 'services/RawData/driver_services'
import { SearchItem } from 'pages/Components/SearchBox'
import { cloneDeep } from 'lodash'
import { debounce } from 'utils/debounce'
import logo1 from 'assets/images/logo-tiny.png';
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'

type DriverInformationProps = {
  disabledField: (isDisable?: boolean) => boolean;
  formCreate: FormInstance<any>;
  isCheckedPolicyConfirm: boolean;
  onPolicyConfirmChange: (checked: boolean) => void;
}

const DriverInformation: React.FC<DriverInformationProps> = (props) => {
  const { disabledField, formCreate } = props
  const { t } = useTranslation();
  const vendorNumber = Form.useWatch("vendorNumber", formCreate)
  // danh sách tài xế
  const [dropdownDriver, setDropdownDriver] = useState<Driver[]>([])
  // loading Search driver
  const [searchDriverLoading, setSearchDriverLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(props.isCheckedPolicyConfirm);
  const [openModal, setOpenModal] = useState(false);
  const handleCheckboxChange = async (e: CheckboxChangeEvent) => {
    const checked = e.target.checked;
    setIsChecked(checked);
    props.onPolicyConfirmChange(checked); // Gọi hàm callback khi checkbox thay đổi
  };
  // Dropdown tài xế
  const getListDriver = async (driverName?: string) => {
    setSearchDriverLoading(true)
    const request = {
      paging: {
        pageIndex: 1,
        pageSize: 20,
      },
      driverName: driverName,
      actived: true,
      vendorNumber: vendorNumber
    }
    await driverPresenter.searchDriver(driverStore, request);
    setSearchDriverLoading(false)
    if (driverStore.searchDriverResponse?.isSuccess) {
      // AVNMR-67
      // Sửa phiếu_Thêm phiếu _ Dropdown tài xế Thêm Số bằng lái
      const cloneDrivers = cloneDeep(driverStore.searchDriverResponse?.data)
      cloneDrivers.forEach(driver => {
        Object.assign(driver, { driverName: `${driver.driverName} | ${driver.licenseNumber}` })
      })
      setDropdownDriver(cloneDrivers);
    }
    return driverStore.searchDriverResponse.data
  }
  const handleSearchDriver = useCallback(debounce(getListDriver, 300), [searchDriverLoading])
  // danh sách kết quả đào tạo
  const getTrainingResult = async () => {
    if (!commonStore.dropdownTrainingResult.length) {
      await commonPresenter.getDropdownTrainingResult(commonStore)
    }
  }

  useEffect(() => {
    if (vendorNumber) {
      getListDriver()
      getTrainingResult()
    }
  }, [vendorNumber]);

  useEffect(() => {
    setIsChecked(props.isCheckedPolicyConfirm);
  }, [props.isCheckedPolicyConfirm]);


  return (
    <CardBox title={t('waste-handover-plan-register.driver-info.title')} >
      <div className="grid grid-cols-2 gap-x-default">
        {/* -- Tên tài xế ------- */}
        <SearchItem name={'driverName'} label={t('waste-handover-plan-register.driver-info.name')}
          rules={[{ required: true, message: t('waste-handover-plan-register.driver-info.name-required') }]}
        >
          <Select
            disabled={disabledField(true)}
            loading={searchDriverLoading}
            options={dropdownDriver}
            fieldNames={{ label: 'driverName', value: 'driverName' }}
            filterOption={false}
            showSearch
            allowClear
            onSearch={async (value) => {
              handleSearchDriver(value || undefined)
              if (value) {
                formCreate.setFieldValue('driverName', value)
              }
            }}
            onClear={() => {
              formCreate.setFieldsValue({
                driverName: undefined,
                phone: undefined,
                licenseNumber: undefined,
                result: undefined
              })
              getListDriver()
            }}
            onChange={(_, option) => {
              if (option && !Array.isArray(option)) {
                formCreate.setFieldsValue({
                  driverName: option.driverName,
                  phone: option.phone,
                  licenseNumber: option.licenseNumber,
                  result: option.trainingResult
                })
              }
            }}
          />
        </SearchItem>
        {/* -- Số điện thoại ------ */}
        <SearchItem name={'phone'} label={t('waste-handover-plan-register.driver-info.phone')}
          rules={[
            {
              validator: validatePhone,
            },

          ]}>
          <Input disabled={disabledField(true)} />
        </SearchItem>
        {/* số xe */}
        <SearchItem name={'licensePlate'} label={t('waste-handover-plan-register.driver-info.license-plate')}
          rules={[{ required: true, message: t('waste-handover-plan-register.driver-info.license-plate-required') }, { validator: validateLicensePlate }]}
        >
          <Input disabled={disabledField(true)} />
        </SearchItem>
        {/* Số bằng lái */}
        <SearchItem name={'licenseNumber'} label={t('waste-handover-plan-register.driver-info.license-number')}

        // rules={[{ required: true, message: 'Vui lòng nhập "Số bằng lái".' }]}
        >
          <Input disabled={disabledField(true)} />
        </SearchItem>

        {/* Kết quả đào tạo an toàn */}
        <SearchItem initialValue={"DAT"} name={'result'} label={t('waste-handover-plan-register.driver-info.training-result')}
          rules={[{ required: true, message: t('waste-handover-plan-register.driver-info.training-result-required') }]}
        >
          <Select disabled={disabledField(true)} options={commonStore.dropdownTrainingResult} fieldNames={{ label: 'catalogName', value: 'catalogCode' }} />
        </SearchItem>
        {/* Người đi cùng (nếu có) */}
        <SearchItem
          // rootClassName='col-span-2'
          name={'companionInfo'}
          label={t('waste-handover-plan-register.driver-info.companion-info')}
        >
          <Input.TextArea
            disabled={disabledField(true)}
            autoSize={{ minRows: 1, maxRows: 4 }}
          />
        </SearchItem>
      </div>

      <Checkbox disabled={disabledField(true)} style={{ paddingTop: 10 }} checked={isChecked}
        onChange={handleCheckboxChange}>{t('waste-handover-plan-register.driver-info.consent-text')} &nbsp;&nbsp; &nbsp;&nbsp;
        <span className='underline font-bold text-sky-600 cursor-pointer'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpenModal(true);
          }}>
          {t('waste-handover-plan-register.driver-info.consent-view-detail')}
        </span>
      </Checkbox>


      <Modal
        open={openModal}
        width={1000}
        onCancel={() => setOpenModal(false)}
        title={[
          <>
            <div className='flex flex-row gap-x-10'>
              <img src={logo1} className='w-[90px] h-[70px]' alt='logo_avn' />
              <div className='flex flex-1 justify-center'>
                <span className='font-bold text-sky-800 flex items-center justify-center text-[25px] uppercase '>{t('waste-handover-plan-register.driver-info.consent-title')}</span>
              </div>

            </div>
            <Divider />
          </>

        ]}
        footer={[
          <div className='flex flex-row justify-between ml-5'>
            <span className='text-red-500 text-[15px]'>{t('waste-handover-plan-register.driver-info.consent-note')}</span>
          </div>

        ]}
      >
        <span className='text-base mx-5 block my-3' dangerouslySetInnerHTML={{ __html: t('waste-handover-plan-register.driver-info.consent-content') }} />


        <Divider />
      </Modal>
    </CardBox>

  )
}

export default observer(DriverInformation)

